// extracted by mini-css-extract-plugin
export default {"cls1":"Iv3DVC1pZcgFQa99uKhe","cls2":"KBXrB4JNVjsazxeueui6 Iv3DVC1pZcgFQa99uKhe"};